import React from "react";

import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { TextField, FormControlLabel, RadioGroup, Radio, IconButton, Typography, Dialog, Grid, Paper, Checkbox, Button, CircularProgress, InputAdornment } from "@material-ui/core";
import { RadioButtonUnchecked, RadioButtonChecked, Close, CalendarToday, QueryBuilder } from "@material-ui/icons";

import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import PrintIcon from '@material-ui/icons/Print';
import moment from "moment";
//Table imports
import MaterialTable from "material-table";
import tapaStyles from "./tapa.module.css";
import commonStyles from '../common/common.module.css';
import TapaModel from "../../models/TapaForm";
import { KeyboardDatePicker, TimePicker } from "@material-ui/pickers";

const styles = (theme: Theme) =>
  createStyles({
    inputWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    inputLabel: {
      fontSize: '9px',
      color: 'var(--primaryblue)',
      fontWeight: 600,
      paddingLeft: '10px',
      margin: 0
    },
    checkbox: {
      paddingTop: 0,
      '& svg': {
        fontSize: '20px'
      }
    },
    saveBtn: {
      height: '30px',
    },
    followUp: {
      marginTop: '10px',
    },
    dense: {
      width: '84%'
    }
  });

interface TapaInspectionFormProps {
  classes: any;
  handleFormChange: (field: string, event: any) => void;
  handleChecksChange: (field: string, event: any) => void;
  openForm: (type: string) => void;
  tapaForm: TapaModel;
  submit: () => void;
  type: string;
  onBlur: (field: string) => void;
  closeModal: (type: string) => void;
  print: (id: number) => void;
  errors: TapaModel;
  progressBar: boolean;
  handleDateChange: (type: string, date: any) => void;
};

const TapaInspectionForm = (props: TapaInspectionFormProps) => {
  const { classes } = props;

  return (
      <div className= { `${ commonStyles.wrapper } ${ tapaStyles.wrapper2 }` } >
        <div className={ tapaStyles.inspectionHeader }>
          <h3 className={ commonStyles.header }>New Independent Inspection</h3>
          <div className={ tapaStyles.inspectionHeaderButton }>
            <IconButton aria-label="Close" disabled={ props.type !== 'edit' } onClick={() => props.print(props.tapaForm.id) }>
              <PrintIcon color="primary" />
            </IconButton> 
            <IconButton aria-label="Close"  onClick={() => props.closeModal('form') }>
              <Close color="primary" />
            </IconButton> 
          </div>
        </div>
        <div>
          <Grid container>
            <Grid item md={7} xs={12} className={ [tapaStyles.outerGridItems, tapaStyles.criteriaItems].join(" ") } >
              <h4 className={ tapaStyles.heading }>Inspection Criteria</h4>
              <div>
                <div className={ tapaStyles.criteriaLists }>
                  <FormControlLabel
                    value=""
                    control={
                      <Checkbox
                        name=''
                        icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                        checkedIcon={<CheckBoxIcon color="primary"/>}
                        classes={{
                          root: classes.checkbox,
                        }}
                        onChange={ (event) => props.handleChecksChange('undercarriage_check', event) }
                        checked={props.tapaForm.undercarriage_check}
                      />
                    }
                    className={ `${ tapaStyles.tapaLabelWrapper } ${ tapaStyles.inspectionList }` }
                    label={
                      <Typography >
                        <p className={ tapaStyles.lists }> Outside & Undercarriage</p>
                        <div className={ tapaStyles.listText }>
                          <p>a) Inspect prior to staging at dock entry point to the warehouse</p>
                          <p>b) Support beams should be visible</p>
                          <p>c) Look for concealed stowage or hidden articles</p>
                          <p>d) For flatbed trailers, inspect tarp boxes</p>
                        </div>
                      </Typography>
                    }
                  />
                  {props.tapaForm.undercarriage_check && <div className={ tapaStyles.timeDateWrapper }>
                    <div className={ tapaStyles.timeDateContent }>
                      <p>{ moment(props.tapaForm.undercarriage_check_date).format('DD MMM YY') }</p>
                      <p>Date</p>
                    </div>
                    <div className={ tapaStyles.timeDateContent }>
                      <p>{ props.tapaForm.undercarriage_checked_user}</p>
                      <p>Name</p>
                    </div>    
                  </div>}
                </div>

                <div className={ tapaStyles.criteriaLists }>
                  <FormControlLabel
                    value=""
                    control={
                      <Checkbox
                        name=''
                        icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                        checkedIcon={<CheckBoxIcon color="primary"/>}
                        classes={{
                          root: classes.checkbox,
                        }}
                        onChange={ (event) => props.handleChecksChange('inside_doors_check', event) }
                        checked={props.tapaForm.inside_doors_check}
                      />
                    }
                    className={ `${ tapaStyles.tapaLabelWrapper } ${ tapaStyles.inspectionList }` }
                    label={
                      <Typography >
                        <p className={ tapaStyles.lists }>Outside & Inside Doors </p>
                        <div className={ tapaStyles.listText }>
                          <p>a) Secure and reliable locking mechanisms</p>
                          <p>b) Look for different color bonding material</p>
                          <p>c) Look for loose bolts</p>
                          <p>d) Check plates for any repairs</p>
                        </div>
                      </Typography>
                    }
                  />
                  {props.tapaForm.inside_doors_check && <div className={ tapaStyles.timeDateWrapper }>
                    <div className={ tapaStyles.timeDateContent }>
                      <p>{ moment(props.tapaForm.inside_doors_check_date).format('DD MMM YY') }</p>
                      <p>Date</p>
                    </div>
                    <div className={ tapaStyles.timeDateContent }>
                      <p>{ props.tapaForm.inside_checked_user }</p>
                      <p>Name</p>
                    </div>    
                  </div>}
                </div>

                <div className={ tapaStyles.criteriaLists }>
                  <FormControlLabel
                    value=""
                    control={
                      <Checkbox
                        name=''
                        icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                        checkedIcon={<CheckBoxIcon color="primary"/>}
                        classes={{
                          root: classes.checkbox,
                        }}
                        onChange={ (event) => props.handleChecksChange('right_side_check', event) }
                        checked={props.tapaForm.right_side_check}
                      />
                    }
                    className={ `${ tapaStyles.tapaLabelWrapper } ${ tapaStyles.inspectionList }` }
                    label={
                      <Typography >
                        <p className={ tapaStyles.lists }>  Right Side</p>
                        <div className={ tapaStyles.listText }>
                          <p>a) Look for any unusual repairs to structural beams panels or rails</p>
                          <p>b) Look for concealed walls or hidden articles</p>
                          <p>c) Use a tool to tap side walls. Listen and feel for hollow sounds</p>
                        </div>
                      </Typography>
                    }
                  />
                  {props.tapaForm.right_side_check && <div className={ tapaStyles.timeDateWrapper }>
                    <div className={ tapaStyles.timeDateContent }>
                      <p>{ moment(props.tapaForm.right_side_check_date).format('DD MMM YY') }</p>
                      <p>Date</p>
                    </div>
                    <div className={ tapaStyles.timeDateContent }>
                      <p>{ props.tapaForm.rightside_checked_user }</p>
                      <p>Name</p>
                    </div>    
                  </div>}
                </div>

              <div className={ tapaStyles.criteriaLists }>
                <FormControlLabel
                  value=""
                  control={
                    <Checkbox
                      name=''
                      icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                      checkedIcon={<CheckBoxIcon color="primary"/>}
                      classes={{
                        root: classes.checkbox,
                      }}
                      onChange={ (event) => props.handleChecksChange('left_side_check', event) }
                      checked={props.tapaForm.left_side_check}
                    />
                  }
                  className={ `${ tapaStyles.tapaLabelWrapper } ${ tapaStyles.inspectionList }` }
                  label={
                    <Typography >
                      <p className={ tapaStyles.lists }>Left Side </p>
                      <div className={ tapaStyles.listText }>
                        <p>a) Look for any unusual repairs to structural beams panels or rails</p>
                        <p>b) Look for concealed walls or hidden articles</p>
                        <p>c) Use a tool to tap side walls. Listen and feel for hollow sounds</p>
                        <p></p>
                      </div>
                    </Typography>
                  }
                />
                { props.tapaForm.left_side_check && <div className={ tapaStyles.timeDateWrapper }>
                  <div className={ tapaStyles.timeDateContent }>
                    <p>{ moment(props.tapaForm.left_side_check_date).format('DD MMM YY') }</p>
                    <p>Date</p>
                  </div>
                  <div className={ tapaStyles.timeDateContent }>
                    <p>{ props.tapaForm.leftside_checked_user }</p>
                    <p>Name</p>
                  </div>    
                </div> }
              </div>

              <div className={ tapaStyles.criteriaLists }>
                <FormControlLabel
                  value=""
                  control={
                    <Checkbox
                      name=''
                      icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                      checkedIcon={<CheckBoxIcon color="primary"/>}
                      classes={{
                        root: classes.checkbox,
                      }}
                      onChange={ (event) => props.handleChecksChange('front_wall_check', event) }
                      checked={props.tapaForm.front_wall_check}
                    />
                  }
                  className={ `${ tapaStyles.tapaLabelWrapper } ${ tapaStyles.inspectionList }` }
                  label={
                    <Typography >
                      <p className={ tapaStyles.lists }> Front Wall </p>
                      <div className={ tapaStyles.listText }>
                        <p>a) Check that blocks and vents are visible</p>
                        <p>b) Make sure that the length of the interior of the trailer is correct</p>
                        <p>c) Look for cencealed walls or hidden articles</p>
                        <p>d) Use a tool to tap front wall. Listen and feel for hollow sound.</p>
                      </div>
                    </Typography>
                  }
                />
                { props.tapaForm.front_wall_check && <div className={ tapaStyles.timeDateWrapper }>
                  <div className={ tapaStyles.timeDateContent }>
                    <p>{ moment(props.tapaForm.front_wall_check_date).format('DD MMM YY') }</p>
                    <p>Date</p>
                  </div>
                  <div className={ tapaStyles.timeDateContent }>
                    <p>{ props.tapaForm.frontwall_checked_user }</p>
                    <p>Name</p>
                  </div>    
                </div> }
              </div>

              <div className={ tapaStyles.criteriaLists }>
                <FormControlLabel
                  value=""
                  control={
                    <Checkbox
                      name=''
                      icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                      checkedIcon={<CheckBoxIcon color="primary"/>}
                      classes={{
                        root: classes.checkbox,
                      }}
                      onChange={ (event) => props.handleChecksChange('roof_check', event) }
                      checked={ props.tapaForm.roof_check }
                    />
                  }
                  className={ `${ tapaStyles.tapaLabelWrapper } ${ tapaStyles.inspectionList }` }
                  label={
                    <Typography >
                      <p className={ tapaStyles.lists }> Ceiling & Roof</p>
                      <div className={ tapaStyles.listText }>
                        <p>a) Ensure ceiling is a certain height from the floor</p>
                        <p>b) Look for concealed ceiling / roof or hidden articles</p>
                        <p>c) Repairs to the ceiling on the inside of the trailer should be visible from the outside</p>
                        <p></p>
                      </div>
                    </Typography>
                  }
                />
                { props.tapaForm.roof_check && <div className={ tapaStyles.timeDateWrapper }>
                  <div className={ tapaStyles.timeDateContent }>
                    <p>{ moment(props.tapaForm.roof_check_date).format('DD MMM YY') }</p>
                    <p>Date</p>
                  </div>
                  <div className={ tapaStyles.timeDateContent }>
                    <p>{ props.tapaForm.roof_checked_user }</p>
                    <p>Name</p>
                  </div>    
                </div>}
              </div>
                
              <div className={ tapaStyles.criteriaLists }>
                <FormControlLabel
                  value=""
                  control={
                    <Checkbox
                      name=''
                      icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                      checkedIcon={<CheckBoxIcon color="primary"/>}
                      classes={{
                        root: classes.checkbox,
                      }}
                      onChange={ (event) => props.handleChecksChange('floor_check', event) }
                      checked={ props.tapaForm.floor_check }
                    />
                  }
                  className={ `${ tapaStyles.tapaLabelWrapper } ${ tapaStyles.inspectionList }` }
                  label={
                    <Typography >
                      <p className={ tapaStyles.lists }>Floor (Inside) </p>
                      <div className={ tapaStyles.listText }>
                        <p>a) Floor should be a certain height from the ceiling & flat</p>
                        <p>b) Check to make sure that the floor is a uniform height</p>
                        <p>c) Look for concealed false floor or hidden articles</p>
                        <p>d) Be on the lookout for any unsual repairs.</p>
                      </div>
                    </Typography>
                  }
                />
                {props.tapaForm.floor_check && <div className={ tapaStyles.timeDateWrapper }>
                  <div className={ tapaStyles.timeDateContent }>
                    <p>{ moment(props.tapaForm.floor_check_date).format('DD MMM YY') }</p>
                    <p>Date</p>
                  </div>
                  <div className={ tapaStyles.timeDateContent }>
                    <p>{ props.tapaForm.floor_checked_user }</p>
                    <p>Name</p>
                  </div>    
                </div>}
              </div>
                
              </div>
            </Grid>
            <Grid item md={5} xs={12} direction="column" className={ tapaStyles.outerGridItems }>
              <Grid container>
                <Grid item xs={12} className={ tapaStyles.innerGridItems }>
                <h4 className={ tapaStyles.heading }>Truck Details</h4>
                  
                  <Grid container>
                    <Grid item xs={8} className={ tapaStyles.truckDetailsGridItems }>
                      <div className={ `${ tapaStyles.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
                        <label className={ commonStyles.inputLabel }>RFS Truck Number<span className={ tapaStyles.asterisk }>*</span></label>
                        <TextField
                          required
                          id='truck_number'
                          variant='outlined'
                          value={ props.tapaForm.truck_number }
                          onChange={ (event) => props.handleFormChange('truck_number', event) }
                          InputProps={{
                            classes: { input: classes.input }
                          }}
                          InputLabelProps={{
                            className: classes.blue
                          }}
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid item xs={4} className={ tapaStyles.truckDetailsGridItems }>
                      <div className={ `${ tapaStyles.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
                        <label className={ commonStyles.inputLabel }>Origin<span className={ tapaStyles.asterisk }>*</span></label>
                        <TextField
                          required
                          id='origin'
                          variant='outlined'
                          value={ props.tapaForm.origin }
                          onChange={ (event) => props.handleFormChange('origin', event) }
                          InputProps={{
                            classes: { input: classes.input }
                          }}
                          InputLabelProps={{
                            className: classes.blue
                          }}
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} className={ tapaStyles.truckDetailsGridItems }>
                      <div className={ `${ tapaStyles.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
                        <label className={ commonStyles.inputLabel }>Carrier<span className={ tapaStyles.asterisk }>*</span></label>
                        <TextField
                          required
                          id='carrier'
                          variant='outlined'
                          value={ props.tapaForm.carrier }
                          onChange={ (event) => props.handleFormChange('carrier', event) }
                          InputProps={{
                            classes: { input: classes.input }
                          }}
                          InputLabelProps={{
                            className: classes.blue
                          }}
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} className={ tapaStyles.truckDetailsGridItems }>
                      <div className={ `${ tapaStyles.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
                        <label className={ commonStyles.inputLabel }>Driver<span className={ tapaStyles.asterisk }>*</span></label>
                        <TextField
                          required
                          id='driver_name'
                          variant='outlined'
                          value={ props.tapaForm.driver_name }
                          onChange={ (event) => props.handleFormChange('driver_name', event) }
                          InputProps={{
                            classes: { input: classes.input }
                          }}
                          InputLabelProps={{
                            className: classes.blue
                          }}
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid item xs={4} className={ `${ tapaStyles.truckDetailsGridItems } ${ tapaStyles.flexEnd }` }>
                      <div className={ `${ tapaStyles.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
                        <label className={ commonStyles.inputLabel }>Tractor License Plate<span className={ tapaStyles.asterisk }>*</span></label>
                        <TextField
                          required
                          id='tractor_license'
                          variant='outlined'
                          value={ props.tapaForm.tractor_license }
                          onChange={ (event) => props.handleFormChange('tractor_license', event) }
                          InputProps={{
                            classes: { input: classes.input }
                          }}
                          InputLabelProps={{
                            className: classes.blue
                          }}
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid item xs={4} className={ `${ tapaStyles.truckDetailsGridItems } ${ tapaStyles.flexEnd }` }>
                      <div className={ `${ tapaStyles.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
                        <label className={ commonStyles.inputLabel }>Trailer License Plate<span className={ tapaStyles.asterisk }>*</span></label>
                        <TextField
                          required
                          id='trailer_license'
                          variant='outlined'
                          value={ props.tapaForm.trailer_license }
                          onChange={ (event) => props.handleFormChange('trailer_license', event) }
                          InputProps={{
                            classes: { input: classes.input }
                          }}
                          InputLabelProps={{
                            className: classes.blue
                          }}
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid item xs={4} className={ `${ tapaStyles.truckDetailsGridItems } ${ tapaStyles.flexEnd }` }>
                      <div className={ `${ tapaStyles.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
                        <label className={ commonStyles.inputLabel }>Trailer Number<span className={ tapaStyles.asterisk }>*</span></label>
                        <TextField
                          required
                          id='trailer_number'
                          variant='outlined'
                          value={ props.tapaForm.trailer_number }
                          onChange={ (event) => props.handleFormChange('trailer_number', event) }
                          InputProps={{
                            classes: { input: classes.input }
                          }}
                          InputLabelProps={{
                            className: classes.blue
                          }}
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid item xs={4} className={ tapaStyles.truckDetailsGridItems }>
                      <div className={ `${ tapaStyles.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
                        <label className={ commonStyles.inputLabel }>Seal number on arrival<span className={ tapaStyles.asterisk }>*</span></label>
                        <TextField
                          required
                          id='seal_arrival'
                          variant='outlined'
                          value={ props.tapaForm.seal_arrival }
                          onChange={ (event) => props.handleFormChange('seal_arrival', event) }
                          InputProps={{
                            classes: { input: classes.input }
                          }}
                          InputLabelProps={{
                            className: classes.blue
                          }}
                          onBlur={ () => props.onBlur('seal_arrival') }
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid item xs={8} className={ `${ tapaStyles.truckDetailsGridItems } ${ tapaStyles.alignMiddle }` }>
                    { props.tapaForm.seal_arrival && <p className={ tapaStyles.fontSize12 }>Checked By:   { props.tapaForm.seal_arrival_checked_user } |  { moment(props.tapaForm.user_arrival_seal_date).format('DD MMM YY hh:mm') }</p>}
                    </Grid>

                    <Grid item xs={4} className={ tapaStyles.truckDetailsGridItems }>
                      <div className={ `${ tapaStyles.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
                        <label className={ commonStyles.inputLabel }>Seal number on departure<span className={ tapaStyles.asterisk }>*</span></label>
                        <TextField
                          required
                          id='seal_departure'
                          variant='outlined'
                          value={ props.tapaForm.seal_departure }
                          onChange={ (event) => props.handleFormChange('seal_departure', event) }
                          InputProps={{
                            classes: { input: classes.input }
                          }}
                          InputLabelProps={{
                            className: classes.blue
                          }}
                          onBlur={ () => props.onBlur('seal_departure') }
                          fullWidth
                        />
                      </div>
                    </Grid>

                    <Grid item xs={8} className={ `${ tapaStyles.truckDetailsGridItems } ${ tapaStyles.alignMiddle }` }>
                    { props.tapaForm.seal_departure && <p className={ tapaStyles.fontSize12 }> Checked by:  { props.tapaForm.seal_departure_checked_user } |  { moment(props.tapaForm.user_departure_seal_date).format('DD MMM YY hh:mm') }</p> }
                    </Grid>
                    <Grid item xs={6} className={ [tapaStyles.truckDetailsGridItems, tapaStyles.checkGrid ].join(" ") }>
                      <div className={ tapaStyles.additionalheckWrapper }>
                        <FormControlLabel 
                          value="" 
                          control={
                            <Checkbox
                              checked={ props.tapaForm.seal_checked }
                              onChange={ (event) => props.handleChecksChange('seal_checked', event) }
                              icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                              checkedIcon={<CheckBoxIcon color="primary"/>}
                              color="primary"
                            />
                          } 
                          className={ tapaStyles.tapaLabelWrapper }
                          label={"Physical Integrity of seals"}
                          />
                        
                      </div>
                    </Grid>
                    <Grid item xs={6} className={ `${ tapaStyles.truckDetailsGridItems } ${ tapaStyles.alignMiddle }` }>
                    { props.tapaForm.seal_checked && <p className={ tapaStyles.fontSize12 }> Checked by:  { props.tapaForm.seal_checked_user } |  { moment(props.tapaForm.seal_check_date).format('DD MMM YY hh:mm') }</p> }
                    </Grid>
                  </Grid>
                
                </Grid>
                <Grid item xs={12} className={`${ tapaStyles.innerGridItems } ${ tapaStyles.additionalChecks } ${ commonStyles.pb3 }` }>
                  <h4 className={ tapaStyles.heading }>Follow Up Inspection</h4>
                  <div className={ tapaStyles.additionalheckWrapper }>
                    <Grid className={ tapaStyles.truckDetailsGridItems }>
                      <div className={ tapaStyles.timeDateWrapper }>
                      <div className={ [tapaStyles.timeDateContent, tapaStyles.dateStyle].join(" ") }>
                        <KeyboardDatePicker
                          value={ props.tapaForm.follow_up_date }
                          onChange={ (event) => props.handleDateChange('follow_up_date', event) }
                          format={"DD MMM YYYY"}
                          fullWidth
                          inputVariant="outlined"
                          autoOk
                        />
                      </div>    
                      <div className={ [tapaStyles.timeDateContent, tapaStyles.dateStyle].join(" ") }>
                        <TimePicker
                          clearable
                          format={ "HH:mm" }
                          value={ moment( props.tapaForm.follow_up_time, "HH:mm")}
                          onChange={ (event) => props.handleDateChange('follow_up_time', event) }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end" >
                                <QueryBuilder color='primary' />
                              </InputAdornment>
                            )
                          }}
                          fullWidth
                          inputVariant="outlined"
                          autoOk
                        />
                      </div>   
                    </div>
                    </Grid>
                    <div className={`${ classes.followUp } ${ commonStyles.inputLabelWrapper } ${ tapaStyles.truckDetailsGridItems }`}>
                      <label className={ commonStyles.inputLabel }>Name</label>
                      <TextField
                        id="standard-dense"
                        label=""
                        className={ classes.dense }
                        onChange={ (event) => props.handleFormChange('follow_up_name', event) }
                        value={ props.tapaForm.follow_up_name }
                        variant="outlined"
                      />
                    </div> 
                  </div>

                </Grid>

              </Grid>

            </Grid>
            <Grid item md={12} xs={12} className={`${ tapaStyles.outerGridItems } ${ tapaStyles.additionalRemarks }` }>
              <div className={`${ commonStyles.inputLabelWrapper } ${ commonStyles.m0 }` } >
                <label className={ commonStyles.inputLabel }>Any Additional Remarks</label>
                <TextField
                  required
                  id='remarks'
                  variant='outlined'
                  value={ props.tapaForm.remarks }
                  onChange={ (event) => props.handleFormChange('remarks', event) }
                  InputProps={{
                    classes: { input: classes.input }
                  }}
                />
              </div>
              { props.progressBar && <CircularProgress className={classes.progress} /> }
              { !props.progressBar && <Button color="primary"
                variant="contained" 
                onClick={ () => props.submit() }
                className={ classes.saveBtn }
                disabled={ props.progressBar }
                >
                Save
              </Button> }
            </Grid>
          </Grid>
        </div>
          
      </div>
  );
};

export default withStyles(styles)(TapaInspectionForm);
